import type { RefObject } from "react";
import { useEffect, useState } from "react";
interface FocusOptions {
    focusVisible?: boolean;
}
export function useContainsFocus(ref: RefObject<HTMLElement>, focusOptions?: FocusOptions) {
    const [containsFocused, setContainsFocused] = useState(false);
    useEffect(() => {
        const container = ref.current;
        const requiresFocusVisible = focusOptions?.focusVisible ?? false;
        if (container) {
            const onFocusIn = (e: FocusEvent) => {
                if (requiresFocusVisible) {
                    setContainsFocused(elementHasFocusVisible(e.target));
                }
                else {
                    setContainsFocused(true);
                }
            };
            const onFocusOut = (e: FocusEvent) => {
                if (!(e.relatedTarget instanceof HTMLElement) || !container.contains(e.relatedTarget)) {
                    setContainsFocused(false);
                }
            };
            container.addEventListener("focusin", onFocusIn);
            container.addEventListener("focusout", onFocusOut);
            return () => {
                container.removeEventListener("focusin", onFocusIn);
                container.removeEventListener("focusout", onFocusOut);
            };
        }
    }, [focusOptions?.focusVisible, ref]);
    return containsFocused;
}
function elementHasFocusVisible(element: EventTarget | Element | null) {
    return element instanceof HTMLElement && element.matches(":focus-visible");
}
